
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { User } from '@supabase/supabase-js';
import { toast } from 'sonner';

export const useJoinTrip = () => {
  const [joining, setJoining] = useState(false);
  const navigate = useNavigate();

  const joinTrip = async (tripDetails: { id: string; name: string }, user: User | null, inviteCode: string | null) => {
    if (!user) {
      sessionStorage.setItem('pendingInviteCode', inviteCode || '');
      navigate('/auth');
      return;
    }

    if (!tripDetails) return;

    setJoining(true);
    try {
      const { error } = await supabase
        .from('trip_members')
        .insert({
          trip_id: tripDetails.id,
          user_id: user.id
        });

      if (error) {
        if (error.code === '23505') {
          toast.info("You're already a member of this trip");
          return { joined: true };
        } else {
          console.error('Error joining trip:', error);
          toast.error('Failed to join trip');
          return { joined: false };
        }
      } else {
        toast.success(`You've joined "${tripDetails.name}"!`);
        
        // Redirect to trip page after a short delay
        setTimeout(() => {
          navigate(`/trips/${tripDetails.id}/itinerary`);
        }, 1500);
        return { joined: true };
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Something went wrong');
      return { joined: false };
    } finally {
      setJoining(false);
    }
  };

  return {
    joinTrip,
    joining
  };
};
